import { WorkoutsAutoComplteComponent } from './WorkoutsAutoComplteComponent';

export default WorkoutsAutoComplteComponent;
